import { render, staticRenderFns } from "./ProjectReportMarket.vue?vue&type=template&id=21372cbc"
import script from "./ProjectReportMarket.vue?vue&type=script&lang=js"
export * from "./ProjectReportMarket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports